import { render, staticRenderFns } from "./GradesHeader.vue?vue&type=template&id=1a88048b"
import script from "./GradesHeader.vue?vue&type=script&lang=js"
export * from "./GradesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports